import { makeVar, useReactiveVar } from '@apollo/client';
import { useCallback } from 'react';

import type { GetCurrentActivitiesEditorsSubscription } from '../../lesson-builder.graphql.generated';
import type { Pluck } from 'lib/gql/pluck';

// Reactive variable to store current editors
export const activityBuilderEditors = makeVar<
  Pluck<
    GetCurrentActivitiesEditorsSubscription,
    'getCurrentActivitiesEditors'
  >[]
>([]);

export const useActivityBuilderEditors = () => {
  const editors = useReactiveVar(activityBuilderEditors);

  const addEditor = useCallback(
    (
      editor: Pluck<
        GetCurrentActivitiesEditorsSubscription,
        'getCurrentActivitiesEditors'
      >
    ) => {
      const current = activityBuilderEditors();
      // Only add if not already present
      if (!current.find(e => e.editorId === editor.editorId)) {
        activityBuilderEditors([...current, editor]);
      }
    },
    []
  );

  const removeEditor = useCallback((editorId: number) => {
    const current = activityBuilderEditors();
    activityBuilderEditors(current.filter(e => e.editorId !== editorId));
  }, []);

  const setEditors = useCallback(
    (
      editors: Pluck<
        GetCurrentActivitiesEditorsSubscription,
        'getCurrentActivitiesEditors'
      >[]
    ) => {
      activityBuilderEditors(editors);
    },
    []
  );

  const clearEditors = useCallback(() => {
    activityBuilderEditors([]);
  }, []);

  return {
    editors,
    addEditor,
    removeEditor,
    setEditors,
    clearEditors,
  };
};
